import { UseFormReturn } from 'react-hook-form'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'

interface LegalCounsellingFormProps {
  form: UseFormReturn<any>
  isView?: boolean
}

export function LegalCounsellingForm({ form, isView }: LegalCounsellingFormProps) {
  return (
    <div className="space-y-4">
      <FormField
        control={form.control}
        name="Adverse Party"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Adverse Party *</FormLabel>
            <FormControl>
              <Input {...field} disabled={isView} placeholder="Enter adverse party name" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="Subject Matter"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Subject Matter *</FormLabel>
            <FormControl>
              <Input {...field} disabled={isView} placeholder="Enter subject matter" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="Status"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Status *</FormLabel>
            <FormControl>
              <Input {...field} disabled={isView} placeholder="Enter status" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="Action Taken"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Action Taken *</FormLabel>
            <FormControl>
              <Input {...field} disabled={isView} placeholder="Enter action taken" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  )
}
